import { createContext } from 'react';
const CollapsibleHierarchyContext = createContext();
export default CollapsibleHierarchyContext;
